
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-users",
  components: {},
})
export default class IconUsers extends Vue {
  @Prop() public width!: number;
  @Prop() public height!: number;
  @Prop() public color!: string;

  constructor() {
    super();
  }
}
